import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RelationsDialogEffects } from './store/relations-dialog.effects';
import {
    relationsDialogFeatureKey,
    relationsDialogReducer,
} from './store/relations-dialog.reducer';

export function provideRelationDialogStore(): EnvironmentProviders {
    return importProvidersFrom(
        StoreModule.forFeature(
            relationsDialogFeatureKey,
            relationsDialogReducer,
        ),
        EffectsModule.forFeature(RelationsDialogEffects),
    );
}
